import TdUrlView from './TdUrlView';

export default TdUrlView;
